<template>
  <MainBase>
    <div class="layout-container">
      <router-view />
    </div>
  </MainBase>
</template>

<script>
import MainBase from '@/components/layout/MainBase'

export default {
  name: 'MainLayout',
  components: {
    MainBase
  },
}
</script>

<style lang="scss">
  .layout-container {
    min-height: 750px;
  }
</style>
